import { Link } from "@mui/material";
import { useTranslate } from "react-admin";
import { Link as RouterLink } from "react-router-dom";

import { CrmObject, type CustomerServiceCrmRecordQuery } from "../../generated/graphql";
import { CRM_LINK_SX, crmRecordPath, formatCrmDateTime } from "../../lib/crm";
import { CrmObjectIcon } from "./CrmObjectIcon";
import { CrmTableCard } from "./CrmTableCard";
import { DeletedInSalesforceBadge } from "./DeletedInSalesforceBadge";

type Order = NonNullable<CustomerServiceCrmRecordQuery["customerServiceCrmRecord"]>["contractItemOrders"][number];
const COLUMNS = [
  "orderNumber",
  "recordType",
  "status",
  "exchangeStatus",
  "orderRejected",
  "createdBy",
  "createdAt",
] as const;

export const ContractItemOrders = ({ orders }: { orders: Order[] }) => {
  const translate = useTranslate();
  return (
    <CrmTableCard
      testId="crm-contract-item-orders"
      title={translate("crm.contractItem.orders")}
      icon={<CrmObjectIcon object={CrmObject.Order} size="small" />}
      empty={translate("crm.related.empty")}
      headers={COLUMNS.map(key => translate(`crm.contractItem.${key}`))}
      rows={orders.map(order => ({
        key: order.id,
        cells: [
          <>
            {order.orderSalesforceId ? (
              <Link
                component={RouterLink}
                to={crmRecordPath(CrmObject.Order, order.orderSalesforceId)}
                sx={CRM_LINK_SX}
              >
                {order.orderNumber ?? order.orderSalesforceId}
              </Link>
            ) : (
              order.orderNumber
            )}
            {order.deletedInSalesforceAt && <DeletedInSalesforceBadge deletedAt={order.deletedInSalesforceAt} />}
          </>,
          order.recordType,
          order.status,
          order.exchangeStatus,
          order.orderRejected === null ? null : translate(order.orderRejected ? "crm.record.yes" : "crm.record.no"),
          order.createdBy,
          order.createdAt && formatCrmDateTime(order.createdAt),
        ],
      }))}
    />
  );
};
